import { CodeSection } from 'civil-status/constants/code-subject-section';
import { DatiAssenso, SectionVM } from 'civil-status/view-models/step-form';

export const transformerDatiAssenso = (
  idEvento?: number,
  dataSection?: SectionVM
): DatiAssenso | undefined => {
  if (!dataSection) {
    return undefined;
  }

  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    tipoAssenso:
      dataSection.codeSection === CodeSection.DATI_GENERALI_ASS_RICO_P
        ? '2'
        : dataSection.typeDeclaration || dataSection?.parentRecognition || undefined,
  };
};
